import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface VendorsTableProps {
    vendorId: string; // Add vendorId as a parameter
}

export const VendorContactsTable: React.FC<VendorsTableProps> = ({ vendorId }) => {

    const vendorContactsState = useAppSelector(state => state.vendorContacts);

    return (
        <table className="data">
            <thead>
            <tr>
                <th>Nimi</th>
                <th>Email</th>
                <th>Telefon</th>
                <th className="right w150"></th>
            </tr>
            </thead>
            <tbody>
            {vendorContactsState.vendorContacts?.map(row => {

                const rowClass = (row.banned_at) ? 'reclamation' : '';

                return (
                    <tr key={row.id} className={rowClass}>
                        <td>
                            {row.name}
                        </td>
                        <td>
                            {row.email}
                        </td>
                        <td>
                            {row.phone}
                        </td>
                        <td className="action">
                            <Link to={`/vendors/${vendorId}/contacts/${row.id}/modify`}>Muuda</Link>
                            <span>|</span>
                            <Link to={`/vendors/${vendorId}/contacts/${row.id}/delete`}>Kustuta</Link>
                        </td>
                    </tr>
                )
            })}
            </tbody>
        </table>
    );

}